import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PantallaPrincipalComponent } from './componentes/pantallasGenerales/pantalla-principal/pantalla-principal.component';
import { PantallaContactoComponent } from './componentes/pantallasGenerales/pantalla-contacto/pantalla-contacto.component';
import { PantallaInstitucionalComponent } from './componentes/pantallasGenerales/pantalla-institucional/pantalla-institucional.component';
import { UsuarioLoginComponent } from './componentes/pantallasGenerales/pantallasLogin/usuario-login/usuario-login.component';
import { PantallaInscripcionesComponent } from './componentes/pantallasGenerales/pantalla-inscripciones/pantalla-inscripciones.component';
import { PantallaPropuestaEducativaComponent } from './componentes/pantallasGenerales/pantalla-propuesta-educativa/pantalla-propuesta-educativa.component';
import { PantallaExamenesComponent } from './componentes/pantallasGenerales/pantalla-examenes/pantalla-examenes.component';
import { PantallaPastoralComponent } from './componentes/pantallasGenerales/pantalla-pastoral/pantalla-pastoral.component';

import { PantallaActosComponent } from './componentes/pantallasGenerales/pantallasComunidad/pantalla-actos/pantalla-actos.component';
import { PantallaConvivenciasComponent } from './componentes/pantallasGenerales/pantallasComunidad/pantalla-convivencias/pantalla-convivencias.component';
import { PantallaEstudiantesComponent } from './componentes/pantallasGenerales/pantallasComunidad/pantalla-estudiantes/pantalla-estudiantes.component';
import { PantallaPromocionesPasadasComponent } from './componentes/pantallasGenerales/pantallasComunidad/pantalla-promociones-pasadas/pantalla-promociones-pasadas.component';
import { PantallaProyectosSolidariosComponent } from './componentes/pantallasGenerales/pantallasComunidad/pantalla-proyectos-solidarios/pantalla-proyectos-solidarios.component';
import { PantallaFiestaSanJeronimoComponent } from './componentes/pantallasGenerales/pantallasComunidad/pantalla-fiesta-san-jeronimo/pantalla-fiesta-san-jeronimo.component';


const ROUTES: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'pantallaPrincipal' },
  { path: 'pantallaPrincipal', component: PantallaPrincipalComponent },
  { path: 'institucional', component: PantallaInstitucionalComponent },
  { path: 'contacto', component: PantallaContactoComponent },
  { path: 'inscripciones', component: PantallaInscripcionesComponent }, 
  { path: 'propuestaEducativa', component: PantallaPropuestaEducativaComponent }, 
  { path: 'examenes', component: PantallaExamenesComponent }, 
  { path: 'pastoral', component: PantallaPastoralComponent }, 

  { path: 'actosEscolares', component: PantallaActosComponent },
  { path: 'convivencias', component: PantallaConvivenciasComponent },
  { path: 'estudiantes', component: PantallaEstudiantesComponent },
  { path: 'promocionesPasadas', component: PantallaPromocionesPasadasComponent },
  { path: 'proyectosSolidarios', component: PantallaProyectosSolidariosComponent },
  { path: 'fiestaSanJeronimo', component: PantallaFiestaSanJeronimoComponent },

  { path: 'loginmisanjeronimo', component: UsuarioLoginComponent },   
  { path: '**', component: PantallaPrincipalComponent }
];



@NgModule({
  imports: [RouterModule.forRoot(ROUTES)],
  exports: [RouterModule]
})
export class AppRoutingModule {


 }
